import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    console.log("CONNECTED!")
  }

  navigate(e) {
    console.log(e)
    console.log("NAVIGATING")
    console.log(this.element.selectedOptions[0].dataset.mobileSelectNavHref)
    Turbo.visit(this.element.selectedOptions[0].dataset.mobileSelectNavHref, { action: "advance"})
  }
}
